export default "__VITE_ASSET__CM4bpen3__"